import { APP_BASE_HREF } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { ThemeModule } from "projects/sepidz-web-framework-shell/src/lib/@theme/theme.module";
import { ExcelModule, GridModule } from "@progress/kendo-angular-grid";
import { RTL } from "@progress/kendo-angular-l10n";
import { LayoutModule } from "@progress/kendo-angular-layout";
import { CoreModule } from "projects/sepidz-web-framework/src/lib/@core/core.module";
import { TreeViewModule } from "@progress/kendo-angular-treeview";
import { BrowserModule } from "@angular/platform-browser";
import { MissetupModule } from "./gnr/missetup/missetup.module";
import { CityModule } from "./gnr/city/city.module";
import { ProvinceModule } from "./gnr/province/province.module";
import { FiscalYearModule } from "./gnr/fiscal-year/fiscal-year.module";
import { UserModule } from "./gnr/user/user.module";
import { RoleModule } from "./gnr/role/role.module";
import { CompanyModule } from "./gnr/company/company.module";
import { BranchModule } from "./gnr/branch/branch.module";
import { PartiesModule } from "./frontoffice/parties/parties.module";
import { CatalogModule } from "./frontoffice/catalog/catalog.module";
import { StimulSoftReportModule } from "./stimul-soft-report/stimul-soft-report.module";
import { SalesModule } from "./frontoffice/sales/sales.module";
import { MessagingModule } from "./frontoffice/messaging/message-template/messaging.module";
import { GroupMessageModule } from "./frontoffice/messaging/group-message/group-message.module";
import { MessageListModule } from "./frontoffice/messaging/message-list/message-list.module";
import { ColorPickerModule } from "ngx-color-picker";
import { AccVoucherModule } from "./backoffice/acc/accvoucher/accvoucher.module";
import { DetailLedgerModule } from "./backoffice/acc/detailledger/detailledger.module";
import { GroupLedgerModule } from "./backoffice/acc/groupledger/groupledger.module";
import { GeneralLedgerModule } from "./backoffice/acc/generalledger/generalledger.module";
import { SubLedgerModule } from "./backoffice/acc/subledger/subledger.module";
import { DetailLedgerKindModule } from "./backoffice/acc/detailledgerkind/detailledgerkind.module";
import { AccVoucherKindModule } from "./backoffice/acc/accvoucherkind/accvoucherkind.module";
import { UnitModule } from "./backoffice/inv/unit/unit.module";
import { WarehouseModule } from "./backoffice/inv/warehouse/warehouse.module";
import { GoodsGroupModule } from "./backoffice/inv/goods-group/goods-group.module";
import { GoodsModule } from "./backoffice/inv/goods/goods.module";
import { InvVoucherKindModule } from "./backoffice/inv/inv-voucher-kind/inv-voucher-kind.module";
import { InvvoucherModule } from "./backoffice/inv/invvoucher/invvoucher.module";
import { ReactiveFormsModule } from "@angular/forms";
import { PrintPolicyModule } from "./frontoffice/prints/print-policy.module";
import { SalonModule } from "./frontoffice/salons/salon.module";
import { OrderModule } from "./frontoffice/order/order.module";
import { ChartsModule } from "ng2-charts";
import { InventpryReviewModule } from "./backoffice/inv/report/inventory-review/inventory-review.module";
import { DashboardModule } from "./frontoffice/review/dashboard/dashboard.module";
import { SecurityReviewModule } from "./frontoffice/review/security-review/security-review.module";
import { CustomerReviewModule } from "./frontoffice/review/customer-review/customer-review.module";
import { SalesReviewModule } from "./frontoffice/review/sales-review/sales-review.module";
import { TakingOfInventoryModule } from "./backoffice/inv/taking-of-inventory/taking-of-inventory.module";
import { InventoryClosingModule } from "./backoffice/inv/inventory-closing/inventory-closing.module";
import { ResetPasswordModule } from "./gnr/resetpassword/resetpassword.module";
import { SaleReportDesinerModule } from "./frontoffice/prints/sale-report-desiner/sale-report-desiner.module";
import { DriverAssignmentModule } from "./frontoffice/driverassignment/driverassignment.module";
import { GeneralLedgerVoucherModule } from "./backoffice/acc/general-ledger-voucher/general-ledger-voucher.module";
import { MovementVoucherModule } from "./backoffice/acc/movement-voucher/movement-voucher.module";
import { VoucherApproveModule } from "./backoffice/acc/voucher-approve/voucher-approve.module";
import { BarCodeReaderFormatModule } from "./gnr/bar-code-reader-format/bar-code-reader-format.module";
import { BankModule } from "./backoffice/trs/bank/bank.module";
import { CashModule } from "./backoffice/trs/cash/cash.module";
import { BankBranchModule } from "./backoffice/trs/bank-branch/bank-branch.module";
import { BankAccountModule } from "./backoffice/trs/bank-account/bank-account.module";
import { TrsConcernModule } from "./backoffice/trs/trs-concern/trs-concern.module";
import { ChequeBookModule } from "./backoffice/trs/cheque-book/cheque-book.module";
import { TrsVoucherKindModule } from "./backoffice/trs/trs-voucher-kind/trs-voucher-kind.module";
import { TrsVoucherModule } from "./backoffice/trs/trs-voucher/trs-voucher.module";
import { TreasuryReviewModule } from "./backoffice/trs/report/treasury-review/treasury-review.module";
import { ReportReviewModule } from "./review/review.module";
import { AccCloseProfitandLossAccountsModule } from "./backoffice/acc/acc-close-profitand-loss-accounts/acc-close-profitand-loss-accounts.module";
import { CreateOpeningJournalVoucherModule } from "./backoffice/acc/create-opening-journal-voucher/create-opening-journal-voucher.module";
import { CreateClosingJournalVoucherModule } from "./backoffice/acc/create-closing-journal-voucher/create-closing-journal-voucher.module";
import { InvBalanceModule } from "./backoffice/inv/inv-balance/inv-balance.module";
import { AccVoucherDetailCommentModule } from "./backoffice/acc/acc-voucher-detail-comment/acc-voucher-detail-comment.module";
import { InvVoucherPricingModule } from "./backoffice/inv/inv-voucher-pricing/inv-voucher-pricing.module";
import { InvNoReferenceVoucherModule } from "./backoffice/inv/report/inv-no-reference-voucher/inv-no-reference-voucher.module";
import { FinancialModule } from "./frontoffice/financial/financial.module";
import { SellKindModule } from "./backoffice/sell/sell-kind/sell-kind.module";
import { SellCustomerModule } from "./backoffice/sell/sell-customer/sell-customer.module";
import { SellCustomerGroupModule } from "./backoffice/sell/sell-customer-group/sell-customer-group.module";
import { PriceListHeaderModule } from "./backoffice/sell/price-list-header/price-list-header.module";
import { SellVoucherKindModule } from "./backoffice/sell/sell-voucher-kind/sell-voucher-kind.module";
import { SellVoucherModule } from "./backoffice/sell/sell-voucher/sell-voucher.module";
import { CustomerReceiptPaymentModule } from "./frontoffice/financial/customer-receipt-payment/customer-receipt-payment.module";
import { DataCenterProcessModule } from "./gnr/data-center-process/data-center-process.module";
import { LocalSettingModule } from "./frontoffice/local-setting/local-setting.module";
import { CurrentBranchModule } from "projects/sepidz-web-framework-shell/src/lib/current-branch/current-branch-form/current-branch.module";
import { CostCenterModule } from "./backoffice/hrm/base-info/cost-center/cost-center.module";
import { PayCompaniesModule } from "./backoffice/hrm/base-info/pay-companies/pay-companies.module";
import { ElementModule } from "./backoffice/hrm/base-info/element/element.module";
import { EmploymentKindModule } from "./backoffice/hrm/base-info/employment-kind/employment-kind.module";
import { JobClassificationModule } from "./backoffice/hrm/base-info/job-classification/job-classification.module";
import { JobsModule } from "./backoffice/hrm/base-info/jobs/jobs.module";
import { OrganizationalPostsModule } from "./backoffice/hrm/base-info/organizational-posts/organizational-posts.module";
import { OrganizationalUnitModule } from "./backoffice/hrm/base-info/organizational-unit/organizational-unit.module";
import { WorkHoursImportHeaderModule } from "./backoffice/hrm/base-info/work-hours-import-header/work-hours-import-header.module";
import { WorkplaceModule } from "./backoffice/hrm/base-info/workplace/workplace.module";
import { JobBaseModule } from "./backoffice/hrm/payment-system/job-base/job-base.module";
import { JobGroupModule } from "./backoffice/hrm/payment-system/job-group/job-group.module";
import { JobRankingModule } from "./backoffice/hrm/payment-system/job-ranking/job-ranking.module";
import { AcademicOrientationModule } from "./backoffice/hrm/reference-lists/academic-orientation/academic-orientation.module";
import { CitizenshipKindModule } from "./backoffice/hrm/reference-lists/citizenship-kind/citizenship-kind.module";
import { CourseTitleModule } from "./backoffice/hrm/reference-lists/course-title/course-title.module";
import { FaithKindModule } from "./backoffice/hrm/reference-lists/faith-kind/faith-kind.module";
import { FieldOfStudyModule } from "./backoffice/hrm/reference-lists/field-of-study/field-of-study.module";
import { FluencyInReadingTheLanguageModule } from "./backoffice/hrm/reference-lists/fluency-in-reading-the-language/fluency-in-reading-the-language.module";
import { FluencyInLanguageConversationModule } from "./backoffice/hrm/reference-lists/fluency-in-language-conversation/fluency-in-language-conversation.module";
import { LanguageKindModule } from "./backoffice/hrm/reference-lists/language-kind/language-kind.module";
import { MartyrFamilayKindModule } from "./backoffice/hrm/reference-lists/martyr-familay-kind/martyr-familay-kind.module";
import { NationalityKindModule } from "./backoffice/hrm/reference-lists/nationality-kind/nationality-kind.module";
import { ProficiencyInWritingModule } from "./backoffice/hrm/reference-lists/proficiency-in-writing/proficiency-in-writing.module";
import { ReasonForDismissalModule } from "./backoffice/hrm/reference-lists/reason-for-dismissal/reason-for-dismissal.module";
import { ReligionKindModule } from "./backoffice/hrm/reference-lists/religion-kind/religion-kind.module";
import { RetirementKindModule } from "./backoffice/hrm/reference-lists/retirement-kind/retirement-kind.module";
import { TaxGroupModule } from "./backoffice/hrm/reference-lists/tax-group/tax-group.module";
import { VeteranWorkShiftKindModule } from "./backoffice/hrm/reference-lists/veteran-work-shift-kind/veteran-work-shift-kind.module";
import { ControlContraryNatureAccountModule } from "./backoffice/acc/control-contrary-nature-account/control-contrary-nature-account.module";
import { AccountReviewModule } from "./backoffice/acc/report/account-review/account-review.module";
import { EducationDegreeModule } from "./backoffice/hrm/reference-lists/education-degree/education-degree.module";
import { HrmLoanToPersonnelModule } from "./backoffice/hrm/loan/hrm-loan-to-personnel.module";
import { HrmWorkCalendarModule } from "./backoffice/hrm/base-info/hrm-work-calendar/hrm-work-calendar.module";
import { HrmTaxTableModule } from "./backoffice/hrm/base-info/hrm-tax-table/hrm-tax-table.module";
import { HrmBankModule } from "./backoffice/hrm/base-info/hrm-bank/hrm-bank.module";
import { HrmBankAccountModule } from "./backoffice/hrm/base-info/hrm-bank-account/hrm-bank-account.module";
import { ProjectModule } from "./backoffice/hrm/base-info/project/project.module";
import { HrmPersonnelModule } from "./backoffice/hrm/hrm-personnel/hrm-personnel.module";
import { HRNotificationHeaderModule } from "./backoffice/hrm/hrnotification-header/hrnotification-header.module";
import { FinanceNotificationHeaderModule } from "./backoffice/hrm/finance-notification-header/finance-notification-header.module";
import { HRNotificationKindModule } from "./backoffice/hrm/base-info/hrnotification-kind/hrnotification-kind.module";
import { MonthlyWorkInformationModule } from "./backoffice/hrm/monthly-work-information/monthly-work-information.module";
import { MonthlySalaryCalculationInformationModule } from "./backoffice/hrm/monthly-salary-calculation-information/monthly-salary-calculation-information.module";
import { HrmPayCurentYearMonthModule } from "./backoffice/hrm/hrm-pay-curent-year-month/hrm-pay-curent-year-month.module";
import { ChangePayCurentYearMonthModule } from "./backoffice/hrm/change-pay-curent-year-month/change-pay-curent-year-month.module";
import { HrmMapReportModule } from "./backoffice/hrm/base-info/hrm-map-report/hrm-map-report.module";
import { BillPayReportModule } from "./backoffice/hrm/report/bill-pay-report.module";
import { HrmReviewModule } from "./backoffice/hrm/report/hrm-review/hrm-review.module";
import { ManagementMessageModule } from "./frontoffice/messaging/management-message/management-message.module";
import { MessageManagementTelephoneModule } from "./frontoffice/messaging/message-management-telephone/message-management-telephone.module";
import { UserSystemLogModule } from "./gnr/user-system-log/user-system-log.module";
import { CostModule } from "./frontoffice/cost/cost.module";
import { MeasurementUnitModule } from "./frontoffice/measurementunit/MeasurementUnit.module";
import { PeopleInfoModule } from "./gnr/people-info/people-info.module";
import { SellCustomerReviewModule } from "./backoffice/sell/report/sell-customer-review/sell-customer-review.module";
import { HrmDiskFormatModule } from "./backoffice/hrm/report/hrm-disk-format/hrm-disk-format.module";
import { TaxPayerSystemModule } from "./frontoffice/TaxPayerSystem/TaxPayerSystem.module";
import { HrmPersonnelElementInitialModule } from "./backoffice/hrm/hrm-personnel-element-initial/hrm-personnel-element-initial.module";
import { CostsSpentReviewModule } from "./frontoffice/review/costs-spent-review/costs-spent-review.module";
import { HrmAccVoucherModule } from "./backoffice/hrm/acc-voucher/hrm-acc-voucher.module";
import { DebtorCreditorNoticesHeaderModule } from "./backoffice/sell/debtor-creditor-notices-header/debtor-creditor-notices-header.module";
import { PortalModule } from "./frontoffice/portal/portal.module";
import { InvModule } from "./frontoffice/inv/Inv.module";
import { ProductConversionModule } from "./backoffice/inv/product-conversion/product-conversion.module";
import { WarehouseGoodsReportModule } from "./backoffice/inv/report/warehouse-goods-report/warehouse-goods-report.module";
import { AccountReportModule } from "./backoffice/acc/report/account-report.module";
import { InventoryReportModule } from "./backoffice/inv/report/Inventory-report.module";
import { OrderReviewModule } from "./frontoffice/review/order-review/order-review.module";

const accModule = [
  LayoutModule,
  MissetupModule,
  BankModule,
  CityModule,
  ProvinceModule,
  FiscalYearModule,
  UserModule,
  RoleModule,
  CompanyModule,
  BranchModule,
  PartiesModule,
  CatalogModule,
  MessagingModule,
  GroupMessageModule,
  AccVoucherModule,
  AccVoucherKindModule,
  GroupLedgerModule,
  GeneralLedgerModule,
  SubLedgerModule,
  DetailLedgerKindModule,
  DetailLedgerModule,
  UnitModule,
  MeasurementUnitModule,
  WarehouseModule,
  GoodsGroupModule,
  GoodsModule,
  InvVoucherKindModule,
  ReportReviewModule,
  InventpryReviewModule,
  DashboardModule,
  SecurityReviewModule,
  CustomerReviewModule,
  CostsSpentReviewModule,
  SalesReviewModule,
  OrderReviewModule,
  TakingOfInventoryModule,
  InventoryClosingModule,
  ResetPasswordModule,
  SaleReportDesinerModule,
  GeneralLedgerVoucherModule,
  MovementVoucherModule,
  VoucherApproveModule,
  InvvoucherModule,
  OrderModule,
  ChartsModule,
  DriverAssignmentModule,
  BarCodeReaderFormatModule,
  CashModule,
  BankBranchModule,
  BankAccountModule,
  TrsConcernModule,
  ChequeBookModule,
  TrsVoucherKindModule,
  TrsVoucherModule,
  TreasuryReviewModule,
  SalesModule,
  MessageListModule,
  ColorPickerModule,
  PrintPolicyModule,
  SalonModule,
  FinancialModule,
  AccCloseProfitandLossAccountsModule,
  CreateClosingJournalVoucherModule,
  CreateOpeningJournalVoucherModule,
  InvBalanceModule,
  AccVoucherDetailCommentModule,
  InvVoucherPricingModule,
  InvNoReferenceVoucherModule,
  SellKindModule,
  SellCustomerModule,
  SellCustomerGroupModule,
  PriceListHeaderModule,
  SellVoucherKindModule,
  SellVoucherModule,
  SellCustomerModule,
  SellCustomerReviewModule,
  CustomerReceiptPaymentModule,
  DataCenterProcessModule,
  LocalSettingModule,
  InvModule,
  CurrentBranchModule,
  CostCenterModule,
  PayCompaniesModule,
  ElementModule,
  EmploymentKindModule,
  JobClassificationModule,
  JobsModule,
  OrganizationalPostsModule,
  OrganizationalUnitModule,
  ProvinceModule,
  WorkHoursImportHeaderModule,
  WorkplaceModule,
  JobBaseModule,
  JobGroupModule,
  JobRankingModule,
  AcademicOrientationModule,
  CitizenshipKindModule,
  CourseTitleModule,
  FaithKindModule,
  FieldOfStudyModule,
  FluencyInReadingTheLanguageModule,
  FluencyInLanguageConversationModule,
  LanguageKindModule,
  MartyrFamilayKindModule,
  NationalityKindModule,
  ProficiencyInWritingModule,
  ReasonForDismissalModule,
  ReligionKindModule,
  RetirementKindModule,
  TaxGroupModule,
  VeteranWorkShiftKindModule,
  ControlContraryNatureAccountModule,
  AccountReviewModule,
  EducationDegreeModule,
  HrmLoanToPersonnelModule,
  HrmWorkCalendarModule,
  HrmTaxTableModule,
  HrmBankModule,
  HrmBankAccountModule,
  ProjectModule,
  HrmPersonnelModule,
  HRNotificationHeaderModule,
  FinanceNotificationHeaderModule,
  HRNotificationKindModule,
  MonthlyWorkInformationModule,
  MonthlySalaryCalculationInformationModule,
  HrmPayCurentYearMonthModule,
  ChangePayCurentYearMonthModule,
  BillPayReportModule,
  HrmMapReportModule,
  HrmReviewModule,
  ManagementMessageModule,
  MessageManagementTelephoneModule,
  UserSystemLogModule,
  CostModule,
  PeopleInfoModule,
  HrmDiskFormatModule,
  PeopleInfoModule,
  TaxPayerSystemModule,
  HrmAccVoucherModule,
  DebtorCreditorNoticesHeaderModule,
  HrmPersonnelElementInitialModule,
  PortalModule,
  LayoutModule,
  MissetupModule,
  BankModule,
  CityModule,
  ProvinceModule,
  FiscalYearModule,
  UserModule,
  RoleModule,
  CompanyModule,
  BranchModule,
  PartiesModule,
  CatalogModule,
  MessagingModule,
  GroupMessageModule,
  AccVoucherModule,
  AccVoucherKindModule,
  GroupLedgerModule,
  GeneralLedgerModule,
  SubLedgerModule,
  DetailLedgerKindModule,
  DetailLedgerModule,
  UnitModule,
  MeasurementUnitModule,
  WarehouseModule,
  GoodsGroupModule,
  GoodsModule,
  InvVoucherKindModule,
  ReportReviewModule,
  InventpryReviewModule,
  DashboardModule,
  SecurityReviewModule,
  CustomerReviewModule,
  CostsSpentReviewModule,
  SalesReviewModule,
  OrderReviewModule,
  TakingOfInventoryModule,
  InventoryClosingModule,
  ResetPasswordModule,
  SaleReportDesinerModule,
  GeneralLedgerVoucherModule,
  MovementVoucherModule,
  VoucherApproveModule,
  InvvoucherModule,
  OrderModule,
  ChartsModule,
  DriverAssignmentModule,
  BarCodeReaderFormatModule,
  CashModule,
  BankBranchModule,
  BankAccountModule,
  TrsConcernModule,
  ChequeBookModule,
  TrsVoucherKindModule,
  TrsVoucherModule,
  TreasuryReviewModule,
  SalesModule,
  MessageListModule,
  ColorPickerModule,
  PrintPolicyModule,
  SalonModule,
  FinancialModule,
  AccCloseProfitandLossAccountsModule,
  CreateClosingJournalVoucherModule,
  CreateOpeningJournalVoucherModule,
  InvBalanceModule,
  AccVoucherDetailCommentModule,
  InvVoucherPricingModule,
  InvNoReferenceVoucherModule,
  SellKindModule,
  SellCustomerModule,
  SellCustomerGroupModule,
  PriceListHeaderModule,
  SellVoucherKindModule,
  SellVoucherModule,
  SellCustomerModule,
  SellCustomerReviewModule,
  CustomerReceiptPaymentModule,
  DataCenterProcessModule,
  LocalSettingModule,
  CurrentBranchModule,
  CostCenterModule,
  PayCompaniesModule,
  ElementModule,
  EmploymentKindModule,
  JobClassificationModule,
  JobsModule,
  OrganizationalPostsModule,
  OrganizationalUnitModule,
  ProvinceModule,
  WorkHoursImportHeaderModule,
  WorkplaceModule,
  JobBaseModule,
  JobGroupModule,
  JobRankingModule,
  AcademicOrientationModule,
  CitizenshipKindModule,
  CourseTitleModule,
  FaithKindModule,
  FieldOfStudyModule,
  FluencyInReadingTheLanguageModule,
  FluencyInLanguageConversationModule,
  LanguageKindModule,
  MartyrFamilayKindModule,
  NationalityKindModule,
  ProficiencyInWritingModule,
  ReasonForDismissalModule,
  ReligionKindModule,
  RetirementKindModule,
  TaxGroupModule,
  VeteranWorkShiftKindModule,
  ControlContraryNatureAccountModule,
  AccountReviewModule,
  EducationDegreeModule,
  HrmLoanToPersonnelModule,
  HrmWorkCalendarModule,
  HrmTaxTableModule,
  HrmBankModule,
  HrmBankAccountModule,
  ProjectModule,
  HrmPersonnelModule,
  HRNotificationHeaderModule,
  FinanceNotificationHeaderModule,
  HRNotificationKindModule,
  MonthlyWorkInformationModule,
  MonthlySalaryCalculationInformationModule,
  HrmPayCurentYearMonthModule,
  ChangePayCurentYearMonthModule,
  BillPayReportModule,
  HrmMapReportModule,
  HrmReviewModule,
  ManagementMessageModule,
  MessageManagementTelephoneModule,
  UserSystemLogModule,
  CostModule,
  PeopleInfoModule,
  HrmDiskFormatModule,
  PeopleInfoModule,
  TaxPayerSystemModule,
  HrmAccVoucherModule,
  DebtorCreditorNoticesHeaderModule,
  HrmPersonnelElementInitialModule,
  PortalModule,
  ProductConversionModule,
  WarehouseGoodsReportModule,
  AccountReportModule,
  InventoryReportModule,
];
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    ThemeModule,
    CoreModule.forRoot(),
    TreeViewModule,
    GridModule,
    StimulSoftReportModule,
    accModule,
    ExcelModule,
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: "/" },
    { provide: RTL, useValue: true },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
